<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { Link, usePage } from "@inertiajs/vue3";

const locale = computed(() => usePage().props.locale);

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import First from "@/Components/First.vue";
import Second from "@/Components/Second.vue";
import Third from "@/Components/Third.vue";
import Fourth from "@/Components/Fourth.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <First />
    <Second />
    <Third />
    <Fourth />
  </PublicLayout>
</template>
